function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { Component } from "react";
import { Link } from "react-router-dom";
import AltContainer from "alt-container";
import Translate from "react-translate-component";
import BindToChainState from "../Utility/BindToChainState";
import ChainTypes from "../Utility/ChainTypes";
import CachedPropertyStore from "stores/CachedPropertyStore";
import BlockchainStore from "stores/BlockchainStore";
import WalletDb from "stores/WalletDb";
import SettingsStore from "stores/SettingsStore";
import SettingsActions from "actions/SettingsActions";
import AccessSettings from "../Settings/AccessSettings";
import Icon from "../Icon/Icon";
import "intro.js/introjs.css";
import guide from "intro.js";
import ReportModal from "../Modal/ReportModal";
import PropTypes from "prop-types";
import { routerTransitioner } from "../../routerTransition";
import LoadingIndicator from "../LoadingIndicator";
import counterpart from "counterpart";
import ChoiceModal from "../Modal/ChoiceModal";
import { ChainStore } from "bitsharesjs";
import ifvisible from "ifvisible";
import { getWalletName } from "branding";
import { Tooltip } from "bitshares-ui-style-guide";

class Footer extends React.Component {
  static propTypes = {
    dynGlobalObject: ChainTypes.ChainObject.isRequired,
    synced: PropTypes.bool.isRequired
  };
  static defaultProps = {
    dynGlobalObject: "2.1.0"
  };

  constructor(props) {
    super(props);
    this.state = {
      hasOutOfSyncModalBeenShownOnce: false,
      isOutOfSyncModalVisible: false,
      isReportModalVisible: false,
      isAccessSettingsPopoverVisible: false,
      showConnectingPopup: false,
      showAccessSettingsTooltip: false
    };
    this.getNode = this.getNode.bind(this);
    this._showOutOfSyncModal = this._showOutOfSyncModal.bind(this);
    this._hideOutOfSyncModal = this._hideOutOfSyncModal.bind(this);
    this._showReportModal = this._showReportModal.bind(this);
    this._hideReportModal = this._hideReportModal.bind(this);
    this._showAccessSettingsTooltip = this._showAccessSettingsTooltip.bind(this);
  }

  _showOutOfSyncModal() {
    this.setState({
      isOutOfSyncModalVisible: true
    });
  }

  _hideOutOfSyncModal() {
    this.setState({
      isOutOfSyncModalVisible: false
    });
  }

  _showReportModal() {
    this.setState({
      isReportModalVisible: true
    });
  }

  _hideReportModal() {
    this.setState({
      isReportModalVisible: false
    });
  }

  componentDidMount() {
    this.checkNewVersionAvailable.call(this);
    this.downloadLink = "https://github.com/evraz-org/evraz-gui/releases/latest";

    let ensure = this._ensureConnectivity.bind(this);

    ifvisible.on("wakeup", function () {
      ensure();
    });
  }

  shouldComponentUpdate(nextProps, nextState) {
    return nextState.isOutOfSyncModalVisible !== this.state.isOutOfSyncModalVisible || nextState.isReportModalVisible !== this.state.isReportModalVisible || nextProps.dynGlobalObject !== this.props.dynGlobalObject || nextProps.backup_recommended !== this.props.backup_recommended || nextProps.rpc_connection_status !== this.props.rpc_connection_status || nextProps.synced !== this.props.synced || nextState.isAccessSettingsPopoverVisible !== this.state.isAccessSettingsPopoverVisible || nextState.showAccessSettingsTooltip !== this.state.showAccessSettingsTooltip;
  }

  checkNewVersionAvailable() {
    if (__ELECTRON__) {
      fetch("https://api.github.com/repos/evraz-org/evraz-gui/releases/latest").then(res => {
        return res.json();
      }).then(function (json) {
        let oldVersion = String(json.tag_name);
        let newVersion = String(APP_VERSION);
        let isReleaseCandidate = APP_VERSION.indexOf("rc") !== -1;

        if (!isReleaseCandidate && oldVersion !== newVersion) {
          this.setState({
            oldVersion
          });
        }
      }.bind(this));
    }
  }

  downloadVersion() {
    var a = document.createElement("a");
    a.href = this.downloadLink;
    a.target = "_blank";
    a.rel = "noopener noreferrer";
    a.style = "display: none;";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  launchIntroJS() {
    const translator = require("counterpart");

    var hintData = document.querySelectorAll("[data-intro]");
    var theme = SettingsStore.getState().settings.get("themes");

    if (hintData.length == 0) {
      this.props.history.push("/help");
    } else {
      guide.introJs().setOptions({
        tooltipClass: theme,
        highlightClass: theme,
        showBullets: false,
        hideNext: true,
        hidePrev: true,
        nextLabel: translator.translate("walkthrough.next_label"),
        prevLabel: translator.translate("walkthrough.prev_label"),
        skipLabel: translator.translate("walkthrough.skip_label"),
        doneLabel: translator.translate("walkthrough.done_label")
      }).start();
    }
  }

  getNodeIndexByURL(url) {
    let nodes = this.props.defaults.apiServer;
    let index = nodes.findIndex(node => !!node && !!node.url && node.url === url);

    if (index === -1) {
      return null;
    }

    return index;
  }

  getCurrentNodeIndex() {
    const {
      props
    } = this;
    let currentNode = this.getNodeIndexByURL.call(this, props.currentNode);
    return currentNode;
  }

  getNode(node = {
    url: "",
    operator: ""
  }) {
    if (!node || !node.url) {
      throw "Node is undefined of has no url";
    }

    const {
      props
    } = this;
    const testNet = node.url.indexOf("testnet") !== -1;
    if (!!node.location && node.location.translate) node.location = counterpart.translate(node.location.translate);
    let title = node.operator + " " + !!node.location ? node.location : "";

    if ("country" in node) {
      title = node.country + (!!title ? " - " + title : "");
    }

    return {
      name: title,
      url: node.url,
      ping: node.url in props.apiLatencies ? props.apiLatencies[node.url] : -1,
      testNet
    };
  }
  /**
   * Returns the current blocktime, or exception if not yet available
   * @returns {Date}
   */


  getBlockTime() {
    let dynGlobalObject = ChainStore.getObject("2.1.0");

    if (dynGlobalObject) {
      let block_time = dynGlobalObject.get("time");

      if (!/Z$/.test(block_time)) {
        block_time += "Z";
      }

      return new Date(block_time);
    } else {
      throw new Error("Blocktime not available right now");
    }
  }
  /**
   * Returns the delta between the current time and the block time in seconds, or -1 if block time not available yet
   *
   * Note: Could be integrating properly with BlockchainStore to send out updates, but not necessary atp
   */


  getBlockTimeDelta() {
    try {
      let bt = (this.getBlockTime().getTime() + ChainStore.getEstimatedChainTimeOffset()) / 1000;
      let now = new Date().getTime() / 1000;
      return Math.abs(now - bt);
    } catch (err) {
      console.log(err);
      return -1;
    }
  }
  /**
   * Closes the out of sync modal if closed
   *
   * @private
   */


  _closeOutOfSyncModal() {
    this._hideOutOfSyncModal();
  }
  /**
   * This method can be called whenever it is assumed that the connection is stale.
   * It will check synced/connected state and notify the user or do automatic reconnect.
   * In general the connection state can be "out of sync" and "disconnected".
   *
   * disconnected:
   *      - dependent on rpc_connection_status of BlockchainStore
   *
   * out of sync:
   *      - reported block time is more than X sec in the past, as reported in
   *        App -> _syncStatus
   *
   * @private
   */


  _ensureConnectivity() {
    // user is not looking at the app, no reconnection effort necessary
    if (!ifvisible.now("active")) return;
    let connected = !(this.props.rpc_connection_status === "closed");

    if (!connected) {
      console.log("Your connection was lost");
      setTimeout(() => {
        this._triggerReconnect();
      }, 50);
    } else if (!this.props.synced) {
      // If the blockchain is out of sync the footer will be rerendered one last time and then
      // not receive anymore blocks, meaning no rerender. Thus we need to trigger any and all
      // handling out of sync state within this one call
      let forceReconnectAfterSeconds = this._getForceReconnectAfterSeconds();

      let askToReconnectAfterSeconds = 10; // Trigger automatic reconnect after X seconds

      setTimeout(() => {
        if (!this.props.synced) {
          this._triggerReconnect();
        }
      }, forceReconnectAfterSeconds * 1000); // Still out of sync?

      if (this.getBlockTimeDelta() > 3) {
        console.log("Your node is out of sync since " + this.getBlockTimeDelta() + " seconds, waiting " + askToReconnectAfterSeconds + " seconds, then we notify you");
        setTimeout(() => {
          // Only ask the user once, and only continue if still out of sync
          if (this.getBlockTimeDelta() > 3 && this.state.hasOutOfSyncModalBeenShownOnce === false) {
            this.setState({
              hasOutOfSyncModalBeenShownOnce: true
            });

            this._showOutOfSyncModal();
          }
        }, askToReconnectAfterSeconds * 1000);
      }
    } else {
      setTimeout(() => {
        this._closeOutOfSyncModal();

        this.setState({
          hasOutOfSyncModalBeenShownOnce: false
        });
      }, 50);
    }
  }

  _getForceReconnectAfterSeconds() {
    return 60;
  }

  _triggerReconnect(honorManualSelection = true) {
    if (honorManualSelection && !routerTransitioner.isAutoSelection()) {
      return;
    }

    if (!routerTransitioner.isTransitionInProgress()) {
      this._closeOutOfSyncModal();

      console.log("Trying to reconnect ..."); // reconnect to anythin

      let promise = routerTransitioner.willTransitionTo(false);
      if (!!promise) setTimeout(() => {
        this.forceUpdate();
      }, 10);
      promise.then(() => {
        console.log("... done trying to reconnect");
      });
    }
  }

  _showAccessSettingsTooltip(showAccessNodeTooltip) {
    if (!this.state.isAccessSettingsPopoverVisible) {
      this.setState({
        showAccessSettingsTooltip: showAccessNodeTooltip
      });
    } else {
      this.setState({
        showAccessSettingsTooltip: false
      });
    }
  }

  render() {
    const autoSelectAPI = "wss://fake.automatic-selection.com";
    const {
      state,
      props
    } = this;
    const {
      synced
    } = props;
    const connected = !(this.props.rpc_connection_status === "closed"); // Current Node Details

    let nodes = this.props.defaults.apiServer;
    let currentNodeIndex = this.getCurrentNodeIndex.call(this);
    let activeNode = this.getNode(nodes[currentNodeIndex] || nodes[0]);

    if (activeNode.url == autoSelectAPI) {
      let nodeUrl = props.activeNode;
      currentNodeIndex = this.getNodeIndexByURL.call(this, nodeUrl);

      if (!!currentNodeIndex) {
        activeNode = this.getNode(nodes[currentNodeIndex]);
      } else {
        activeNode = this.getNode(nodes[0]);
      }
    }

    let block_height = this.props.dynGlobalObject.get("head_block_number");
    let version_match = APP_VERSION.match(/\d\.\d\.(\d{6}.{0,1}\d{0,1})/);
    let version = version_match ? `.${version_match[1]}` : ` ${APP_VERSION}`;
    let rc_match = APP_VERSION.match(/-rc[0-9]$/);
    if (rc_match) version += rc_match[0];
    let updateStyles = {
      display: "inline-block",
      verticalAlign: "top"
    };
    let logoProps = {};

    this._ensureConnectivity();

    return /*#__PURE__*/React.createElement("div", null, !!routerTransitioner && routerTransitioner.isTransitionInProgress() && /*#__PURE__*/React.createElement(LoadingIndicator, {
      loadingText: routerTransitioner.getTransitionTarget()
    }), /*#__PURE__*/React.createElement(ChoiceModal, {
      showModal: this._showOutOfSyncModal,
      hideModal: this._hideOutOfSyncModal,
      visible: this.state.isOutOfSyncModalVisible,
      choices: [{
        translationKey: "connection.manual_reconnect",
        callback: () => {
          if (!this.props.synced) {
            this._triggerReconnect(false);
          }
        }
      }, {
        translationKey: "connection.manual_ping_and_narrow_down",
        callback: () => {
          if (!this.props.synced) {
            this.onAccess();
          }
        }
      }]
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Translate, {
      content: "connection.out_of_sync",
      out_of_sync_seconds: parseInt(this.getBlockTimeDelta())
    }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Translate, {
      content: "connection.want_to_reconnect"
    }), routerTransitioner.isAutoSelection() && /*#__PURE__*/React.createElement(Translate, {
      content: "connection.automatic_reconnect",
      reconnect_in_seconds: parseInt(this._getForceReconnectAfterSeconds())
    }))), /*#__PURE__*/React.createElement("div", {
      className: "show-for-medium grid-block shrink footer"
    }, /*#__PURE__*/React.createElement("div", {
      className: "align-justify grid-block"
    }, /*#__PURE__*/React.createElement("div", {
      className: "grid-block"
    }, /*#__PURE__*/React.createElement("div", _extends({
      className: "logo",
      style: {
        fontSize: state.newVersion ? "0.9em" : "1em",
        cursor: state.newVersion ? "pointer" : "normal",
        marginTop: state.newVersion ? "-5px" : "0px",
        overflow: "hidden"
      },
      onClick: state.newVersion ? this.downloadVersion.bind(this) : null
    }, logoProps), state.newVersion && /*#__PURE__*/React.createElement(Icon, {
      name: "download",
      title: counterpart.translate("icons.download", {
        wallet_name: getWalletName()
      }),
      style: {
        marginRight: "20px",
        marginTop: "10px",
        fontSize: "1.35em",
        display: "inline-block"
      }
    }), /*#__PURE__*/React.createElement("span", {
      style: updateStyles
    }, /*#__PURE__*/React.createElement(Translate, {
      content: "footer.title",
      wallet_name: getWalletName()
    }), __GIT_BRANCH__ === "staging" ? /*#__PURE__*/React.createElement("a", {
      href: `https://github.com/bitshares/bitshares-ui/commit/${version.trim()}`,
      className: "version external-link",
      target: "_blank",
      rel: "noopener noreferrer"
    }, version) : /*#__PURE__*/React.createElement("span", {
      className: "version"
    }, version)), /*#__PURE__*/React.createElement("span", null, " ", "-", " ", /*#__PURE__*/React.createElement(Link, {
      to: "/help/disclaimer"
    }, "Disclaimer"), " "), state.newVersion && /*#__PURE__*/React.createElement(Translate, {
      content: "footer.update_available",
      style: {
        color: "#FCAB53",
        position: "absolute",
        top: "8px",
        left: "36px"
      }
    }))), !!routerTransitioner && routerTransitioner.isBackgroundPingingInProgress() && /*#__PURE__*/React.createElement("div", {
      onClick: () => {
        this._showNodesPopover();
      },
      style: {
        cursor: "pointer"
      },
      className: "grid-block shrink txtlabel"
    }, routerTransitioner.getBackgroundPingingTarget(), /*#__PURE__*/React.createElement("div", {
      style: {
        marginTop: "0.4rem",
        marginLeft: "0.5rem"
      }
    }, /*#__PURE__*/React.createElement(LoadingIndicator, {
      type: "circle"
    })), "\xA0 \xA0"), synced ? null : /*#__PURE__*/React.createElement("div", {
      className: "grid-block shrink txtlabel cancel"
    }, /*#__PURE__*/React.createElement(Translate, {
      content: "footer.nosync"
    }), "\xA0 \xA0"), !connected ? /*#__PURE__*/React.createElement("div", {
      className: "grid-block shrink txtlabel error"
    }, /*#__PURE__*/React.createElement(Translate, {
      content: "footer.connection"
    }), "\xA0 \xA0") : null, this.props.backup_recommended ? /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("div", {
      className: "grid-block"
    }, /*#__PURE__*/React.createElement(Tooltip, {
      overlay: /*#__PURE__*/React.createElement("div", null, "Please understand that you are responsible for making your own backup\u2026")
    }, /*#__PURE__*/React.createElement("a", {
      className: "shrink txtlabel facolor-alert",
      onClick: this.onBackup.bind(this)
    }, /*#__PURE__*/React.createElement(Translate, {
      content: "footer.backup"
    }))), "\xA0\xA0")) : null, this.props.backup_brainkey_recommended ? /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("div", {
      className: "grid-block"
    }, /*#__PURE__*/React.createElement("a", {
      className: "grid-block shrink txtlabel facolor-alert",
      onClick: this.onBackupBrainkey.bind(this)
    }, /*#__PURE__*/React.createElement(Translate, {
      content: "footer.brainkey"
    })), "\xA0\xA0")) : null, block_height ? /*#__PURE__*/React.createElement("div", {
      className: "grid-block shrink"
    }, /*#__PURE__*/React.createElement(Tooltip, {
      title: counterpart.translate("tooltip.nodes_popup"),
      mouseEnterDelay: 0.5,
      onVisibleChange: this._showAccessSettingsTooltip,
      visible: this.state.showAccessSettingsTooltip
    }, /*#__PURE__*/React.createElement("div", {
      onClick: () => {
        this._showNodesPopover();
      },
      style: {
        position: "relative",
        cursor: "pointer"
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "footer-status"
    }, connected && activeNode.testNet && /*#__PURE__*/React.createElement("span", {
      className: "testnet"
    }, /*#__PURE__*/React.createElement(Translate, {
      content: "settings.testnet_nodes"
    }), " "), !connected ? /*#__PURE__*/React.createElement("span", {
      className: "warning"
    }, /*#__PURE__*/React.createElement(Translate, {
      content: "footer.disconnected"
    })) : /*#__PURE__*/React.createElement("span", {
      className: "success"
    }, activeNode.name)), /*#__PURE__*/React.createElement("div", {
      className: "footer-block"
    }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("span", {
      className: "footer-block-title"
    }, /*#__PURE__*/React.createElement(Translate, {
      content: "footer.latency"
    })), "\xA0", !connected ? "-" : !activeNode.ping ? "-" : parseInt(activeNode.ping) + "ms", "\xA0/\xA0", /*#__PURE__*/React.createElement("span", {
      className: "footer-block-title"
    }, /*#__PURE__*/React.createElement(Translate, {
      content: "footer.block"
    })), "\xA0#", block_height)))), /*#__PURE__*/React.createElement("div", {
      className: "grid-block"
    }, /*#__PURE__*/React.createElement(Tooltip, {
      title: counterpart.translate("tooltip.debug_report"),
      placement: "topRight",
      mouseEnterDelay: 0.5
    }, /*#__PURE__*/React.createElement("div", {
      className: "introjs-launcher",
      onClick: e => {
        this._showReportModal(e);
      }
    }, /*#__PURE__*/React.createElement(Translate, {
      content: "modal.report.button"
    }))), /*#__PURE__*/React.createElement(Tooltip, {
      title: counterpart.translate("tooltip.self_help"),
      placement: "topRight",
      mouseEnterDelay: 0.5
    }, /*#__PURE__*/React.createElement("div", {
      className: "introjs-launcher",
      onClick: () => {
        this.launchIntroJS();
      }
    }, /*#__PURE__*/React.createElement(Translate, {
      content: "global.help"
    }))))) : /*#__PURE__*/React.createElement("div", {
      className: "grid-block shrink"
    }, /*#__PURE__*/React.createElement(Translate, {
      content: "footer.loading"
    })))), /*#__PURE__*/React.createElement("div", {
      onMouseLeave: () => {
        this.setState({
          isAccessSettingsPopoverVisible: false
        });
      },
      className: "node-access-popup",
      style: {
        display: this.state.isAccessSettingsPopoverVisible ? "" : "none"
      }
    }, /*#__PURE__*/React.createElement(AccessSettings, {
      nodes: this.props.defaults.apiServer,
      popup: true
    }), /*#__PURE__*/React.createElement("div", {
      style: {
        paddingTop: 15
      }
    }, /*#__PURE__*/React.createElement("a", {
      onClick: this.onAccess.bind(this)
    }, /*#__PURE__*/React.createElement(Translate, {
      content: "footer.advanced_settings"
    })))), /*#__PURE__*/React.createElement("div", {
      className: "introjs-launcher show-for-small-only",
      onClick: () => {
        this.launchIntroJS();
      }
    }, /*#__PURE__*/React.createElement(Translate, {
      content: "global.help"
    })), /*#__PURE__*/React.createElement(ReportModal, {
      showModal: this._showReportModal,
      hideModal: this._hideReportModal,
      visible: this.state.isReportModalVisible,
      refCallback: e => {
        if (e) this.reportModal = e;
      }
    }));
  }

  _showNodesPopover() {
    if (this.state.showAccessSettingsTooltip && !this.state.isAccessSettingsPopoverVisible) {
      this.setState({
        isAccessSettingsPopoverVisible: !this.state.isAccessSettingsPopoverVisible,
        showAccessSettingsTooltip: false
      });
    } else {
      this.setState({
        isAccessSettingsPopoverVisible: !this.state.isAccessSettingsPopoverVisible,
        showAccessSettingsTooltip: false
      });
    }
  }

  onBackup() {
    this.props.history.push("/wallet/backup/create");
  }

  onBackupBrainkey() {
    this.props.history.push("/wallet/backup/brainkey");
  }

  onPopup() {
    this.setState({
      isAccessSettingsPopoverVisible: !this.state.isAccessSettingsPopoverVisible
    });
  }

  onAccess() {
    SettingsActions.changeViewSetting({
      activeSetting: 6
    });
    this.props.history.push("/settings/access");
  }

}

Footer = BindToChainState(Footer);

class AltFooter extends Component {
  render() {
    var wallet = WalletDb.getWallet();
    return /*#__PURE__*/React.createElement(AltContainer, {
      stores: [CachedPropertyStore, BlockchainStore, WalletDb, SettingsStore],
      inject: {
        defaults: () => {
          return SettingsStore.getState().defaults;
        },
        apiLatencies: () => {
          return SettingsStore.getState().apiLatencies;
        },
        currentNode: () => {
          return SettingsStore.getState().settings.get("apiServer");
        },
        activeNode: () => {
          return SettingsStore.getState().settings.get("activeNode");
        },
        backup_recommended: () => wallet && (!wallet.backup_date || CachedPropertyStore.get("backup_recommended")),
        rpc_connection_status: () => BlockchainStore.getState().rpc_connection_status
      }
    }, /*#__PURE__*/React.createElement(Footer, this.props));
  }

}

export default AltFooter;